<template>
  <div>
    <div :class="`wistia_embed wistia_async_${id} videoFoam=true`"
         :style="`height:${height}px;position:relative;width:${width}px`">

      <div ref="swatchParent"
           class="wistia_swatch"
           style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">

        <img :src="`https://fast.wistia.com/embed/medias/${id}/swatch`"
             ref="imgTag"
             style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
             alt=""
             aria-hidden="true" />

      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    width: Number,
    height: Number
  },
  mounted() {
    this.$refs.imgTag.onload = this.imgLoad;
  },
  methods: {
    imgLoad: function () {
      this.$refs.swatchParent.style.opacity = 1;
    }
  }
}
</script>